const createInvoiceModel = {
    formId: 'itemForm',
    formField: {
        totalCost: {
            name: 'totalCost',
            label: 'Total Cost',

        },
        development: {
            name: 'development',
        },
        type: {
            name: 'type',
        },
        phase: {
            name: 'phase',
        },
        recurringPeriod: {
            name: 'recurringPeriod',
            label:'Recurring Period (Months)'
        },
        dueDate: {
            name: 'dueDate',
            label: 'Due Date',
        },

        items: {
            name: 'items',
            label: ' Items',
            required: true,
            requiredErrorMsg: 'At least one item is required',
            fields: {
        
                description: {
                    name: 'description',
                    label: 'Description',
                    required: true,
                    requiredErrorMsg: 'Description is required',
                },
                recurringPeriod: {
                    name: 'recurringPeriod',
                    label: 'Recurring Period',
                    required: true,
                    requiredErrorMsg: 'Recurring Period',
                },
                quantity: {
                    name: 'quantity',
                    label: 'Quantity',
                    required: true,
                    requiredErrorMsg: 'Quantity is required',
                },
                unitPrice: {
                    name: 'unitPrice',
                    label: 'Unit Price',
                    required: true,
                    requiredErrorMsg: 'unitPrice is required',
                },
                totalCostPerItem: {
                    name: 'totalAmount',
                    label: 'Total Amount',
                    required: true,
                    requiredErrorMsg: 'Total Amount is required',
                },


            },


        },
    },
    initialValues: {
        totalCost: 0,
        development: '',
        type: '',
        phase: '',
        recurringPeriod: 0,
        dueDate: null,
        items: [{
            description: '',
            quantity: 0,
            unitPrice: 0,
            totalCostPerItem: 0
        }],
    },
};


export type ItemType = {
    quantity: number;
    description: string;
    unitPrice: number;
    totalCostPerItem: number;
};

export default createInvoiceModel;
